{
  "form": {
    "edit": "Bearbeiten",
    "save": "Speichern",
    "cancel": "Abbrechen",
    "delete": "Löschen"
  },
  "stepper": {
    "back": "Zurück",
    "next": "Weiter",
    "finish": "Fertig"
  },
  "notices": {
    "your_session_expired": "Ihre Sitzung ist abgelaufen. Bitte loggen Sie sich erneut ein."
  },
  "table": {
    "actions": "Aktionen"
  },
  "server_validations": {
    "empty_body": "Es ist ein Fehler aufgetreten",
    "invalid_credentials": "Ungültige E-Mail oder Passwort",
    "not_found": "Nicht gefunden",
    "duplicate_email": "E-Mail bereits vergeben",
    "null_not_allowed": "Dieses Feld ist ein Pflichtfeld",
    "missing_value": "Fehlender Wert",
    "invalid_language": "Ungültige Sprache",
    "invalid_number_string": "Nur Ziffern sind erlaubt"
  },
  "home": {
    "user_greeting": "Hallo, {{userName}}",
    "services_status": "Servicestatus",
    "your_organisations": "Ihre Organisationen",
    "no_organizations": "Sie sind in keiner Organisation",
    "your_favorite_services": "Meine Favoriten",
    "no_favorite_services": "Du hast noch keine Favoriten hinzugefügt!",
    "no_organizations_annotation": "Nur Superuser können Organisationen erstellen",
    "no_chart_data": "Es sind noch keine Daten verfügbar. Sobald Sie Ihre ersten Services erstellt haben, werden deren Zustände hier angezeigt!"
  },
  "label": {
    "organization": "Organisation",
    "organizations": "Organisationen",
    "department": "Abteilung",
    "departments": "Abteilungen",
    "ok": "Ok",
    "cancel": "Abbrechen",
    "search": "Suche",
    "accept": "Annehmen",
    "decline": "Ablehnen",
    "cancel_invite": "Einladung zurücknehmen",
    "cancel_registration_invite": "Registrierungs-Einladung zurücknehmen",
    "select_dep": "Abteilung {{id}} auswählen",
    "select_proj": "Projekt {{id}} auswählen",
    "select_clust": "Cluster {{id}} auswählen",
    "select_user": "Benutzer {{id}} auswählen",
    "manage_dep": "Abteilung {{id}} bearbeiten",
    "manage_proj": "Projekt {{id}} bearbeiten",
    "manage_clust": "Cluster {{id}} bearbeiten",
    "remove_user_from_org": "Benutzer {{id}} aus der Organisation entfernen",
    "remove_user_from_dep": "Benutzer {{id}} aus der Abteilung entfernen",
    "remove_user_from_project": "Benutzer {{id}} aus dem Projekt entfernen",
    "leave_org": "Organisation verlassen",
    "notif_item": "Benachrichtigung",
    "default": "Default"
  },
  "steps": {
    "numberOfTotal": "{{number}} von {{total}}"
  },
  "languages": {
    "en": "Englisch",
    "de": "Deutsch",
    "es": "Spanisch"
  },
  "dates": {
    "from_now": "{{date|$from_now}}",
    "long_date": "{{date|$DD. MMMM y}}"
  },
  "dataset_import_errors": {
    "dataset_import_already_processed": "Dieses Datenset wurde bereits importiert oder wird gerade importiert.",
    "dataset_already_queued": "Dieses Datenset its bereit in der Warteschlange.",
    "insufficient_space": "Seit der letzten Überprüfung hat sich der verfügbare Speicherplatz geändert. Bitte versuchen Sie es erneut.",
    "dataset_import_not_readonly": "Dieses Datenset ist nicht schreibgeschützt.",
    "dataset_import_not_present": "Dieses Datenset existiert nicht in der Datenbank.",
    "dataset_import_not_abortable": "Dieser Datenset Import kann nicht abgebrochen werden."
  },
  "errors": {
    "unexpected_error": "Unerwarteter Fehler. Bitte versuchen Sie es später erneut.",
    "internal_error": "Interner Fehler. Bitte kontaktieren Sie Ihren Superuser."
  },
  "delete_entity_error": {
    "has_clusters": "Sie können {{entity_name}} nicht löschen solange es darin laufende Cluster gibt."
  },
  "delete_account_errors": {
    "target_user_is_owner": "Sie sind Besitzer einer Organisation. Bitte entfernen Sie diese vorher.",
    "has_clusters": "Sie besitzen noch aktive Cluster. Bitte entfernen Sie diese vorher."
  },
  "leave_organization_errors": {
    "no_owners_left": "Sie können {{organization_name}} nicht verlassen da Sie der letzte Besitzer der Organisation sind.",
    "has_clusters": "Sie können die Organisation {{organization_name}} nicht verlassen solange es noch laufende Cluster gibt."
  },
  "delete_department_errors": {
    "has_clusters": "Das Department {{department_name}} kann nicht gelöscht, weil Cluster zugeordnet sind."
  },
  "update_cluster_errors": {
    "insufficient_resources": "Der Server hat nicht genügend Ressourcen um diesen Cluster zu erweitern. Bitte kontaktieren Sie Ihren Superuser um mehr Ressourcen zu allokieren, oder versuchen sie es mit einem kleinerem Plan erneut.",
    "is_creating": "Der Cluster kann während der Erstellung nicht editiert werden"
  },
  "node_restart_errors": {
    "node_already_restarting": "Instanz {{instanceId}} ({{instanceRole}}) wird bereits neugestartet.",
    "node_restart_timeout": "Instanz {{instanceId}} ({{instanceRole}}) konnte nicht neugestartet werden - bitte versuchen Sie es später erneut."
  },
  "confirmation": {
    "generate_new_password": "Sind Sie sicher, dass Sie ein neues Passwort generieren möchten?",
    "delete_organization": "Sind Sie sicher, dass Sie die Organisation {{name}} löschen möchten?",
    "delete_department": "Sind Sie sicher, dass Sie die Abteilung {{name}} löschen möchten?",
    "delete_department_plural": "Sind Sie sicher, dass Sie die Abteilungen {{name}} löschen möchten?",
    "delete_project": "Sind Sie sicher, dass Sie das Projekt {{name}} löschen möchten?",
    "delete_project_plural": "Sind Sie sicher, dass Sie die Projekte {{name}} löschen möchten?",
    "delete_cluster": "Sind Sie sicher, dass Sie den Cluster {{name}} löschen möchten?",
    "delete_user_from_organization": "Sind Sie sicher, dass Sie den Benutzer {{name}} aus der Organisation entfernen möchten?",
    "delete_user_from_department": "Sind Sie sicher, dass Sie den Benutzer {{name}} aus der Abteilung entfernen möchten?",
    "delete_user_from_project": "Sind Sie sicher, dass Sie den Benutzer {{name}} aus dem Projekt entfernen möchten?",
    "delete_account": "Sind Sie sicher, dass Sie ihren Account löschen möchten?",
    "leave_dirty_form": "Ihre Änderungen sind nicht gespeichert, sind Sie sicher?",
    "yes": "Ja",
    "no": "Nein"
  },
  "warnings": {
    "exceeded_file_size_with_max": "Ihre Datei ist zu groß (> {{maxSize}})"
  },
  "link_expired": {
    "link_expired": "Link abgelaufen",
    "email_successful": "E-Mail erfolgreich verifiziert",
    "button": "Zurück zu Scalefield"
  },
  "document_title": {
    "app_name": "Scalefield",
    "title": "$t(document_title.app_name) - {{page_title}}"
  },
  "page_titles": {
    "about": "About",
    "profile": "Profil",
    "help": "Hilfe",
    "forgot_password": "Passwort vergessen",
    "login": "Login",
    "sing_up": "Registrieren",
    "home": "Home",
    "support": "Support",
    "organizations": "Organisationen",
    "department_manage": "{{department}} editieren",
    "project_manage": "{{project}} editieren",
    "organization_manage": "{{organization}} editieren",
    "page_not_found": "404 Seite nicht gefunden",
    "help_search": "Hilfe Suche",
    "help_search_results": "Resultate für \"{{query}}\"",
    "system_configuration": "System Einstellungen",
    "email_configuration": "E-Mail Einstellungen",
    "imprint_configuration": "Impressum Einstellungen",
    "imprint": "Impressum",
    "email_test": "E-Mail Test",
    "orphans": "Verwaiste Cluster",
    "whitelisted_orphans": "Waisen Whitelist",
    "non_orphans": "Kunden Cluster"
  },
  "no_item_text": {
    "no_organizations": "Sie haben keine Organisationen.",
    "data_not_found": "Daten nicht gefunden"
  },
  "format_currency": {
    "currency": "{{value|currency}}",
    "currencyShort": "{{value|currencyShort}}"
  },
  "modal": {
    "submit": "Erstellen",
    "cancel": "Abbrechen"
  },
  "reportable_error": {
    "title": "Upps, da ist etwas schief gelaufen.",
    "codes": {
      "unprocessable_entity": "Es scheint ein Problem mit der Struktur der HTTP-Anfrag zu geben.",
      "duplicate_identifier": "Dieser Identifier ist bereits vergeben.",
      "_fallback": "Fehlercode: "
    },
    "click_to_show_more": "Klicken Sie hier für weitere Details...",
    "call_to_action": "Wenn dieses Problem erneut auftritt, würden wir es sehr schätzen, wenn Sie es uns melden könnten.",
    "dismiss": "Schließen"
  }
}
